export const isElectron = (): boolean => {
  if (
    typeof window !== 'undefined' &&
    typeof window.process === 'object' &&
    (window.process as any).type === 'renderer'
  ) {
    return true;
  }
  if (
    typeof process !== 'undefined' &&
    typeof process.versions === 'object' &&
    !!process.versions['electron']
  ) {
    return true;
  }
  return (
    typeof navigator === 'object' && navigator.userAgent.includes('Electron')
  );
};
